import React from 'react';
import { translate } from 'react-i18next';

import { Form } from 'common/components';

const CatalogFormGeneral = ({ catalogs, errors, handleValueChange, isSubmitted, t, values }) => {
  return (
    <Form.Section title={t('catalogs.form.general')}>
      <div className="row align-items-center">
        <div className="col-sm-6 col-md-4 col-lg-3">
          <Form.FieldInput
            error={(isSubmitted && errors.key) || {}}
            name={'key'}
            label={t('catalogs.fields.key')}
            handleChange={handleValueChange}
            value={values.key}
            readOnly
          />
        </div>
        <div className="col-sm-6 col-md-4 col-lg-3">
          <Form.FieldInput
            error={(isSubmitted && errors.name) || {}}
            name={'name'}
            label={t('catalogs.fields.name')}
            handleChange={handleValueChange}
            value={t(values.name)}
            readOnly
          />
        </div>
      </div>
    </Form.Section>
  );
};

export default translate()(CatalogFormGeneral);



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/components/form/sections/CatalogFormGeneral.js